import React from "react";
import { Routes, Route } from "react-router-dom";
import { strings } from "../common/i18n";
import config from "../config";

import Branches from "./Branches";
import Locations from "./Locations/";
import User from "./User/Account";
import Users from "./User/";
import Groups from "./Groups";
// import Settings from "../System/Settings";

export const routePrefix = `../${config.paths.setup}`;

const paths = {
    branches: `${config.paths.branches}`,
    groups: `${config.paths.groups}`,
    financeTypes: `${config.paths.financeTypes}`,
    locations: `${config.paths.locations}`,
    settings: `${config.paths.settings}`,
    user: `:userId`,
    userCreate: `${config.paths.users}/create`,
    users: `${config.paths.users}`
};

export const tabsRoutes = [
    {
        component: <Branches />,
        key: "branches",
        label: strings("branches"),
        path: `${routePrefix}/${paths.branches}`
    },
    {
        component: <Locations />,
        key: "locations",
        label: strings("locations"),
        path: `${routePrefix}/${paths.locations}`
    },
    {
        component: <Users />,
        key: "users",
        label: strings("users"),
        path: `${routePrefix}/${paths.users}`
    },
    {
        component: <Groups />,
        key: "groups",
        label: strings("groups"),
        path: `${routePrefix}/${paths.groups}`
    }
];

export default () => (
    <Routes>
        {/* this is for loading branches  */}
        <Route path="/" element={<Branches />} />
        <Route index path={paths.branches} element={<Branches />} />
        <Route index path={paths.locations} element={<Locations />} />

        <Route path={`${paths.users}/*`} element={<Users />}>
            <Route path=":userId" element={<User />} />
            <Route path="create" element={<User />} />
        </Route>
        <Route path={`${paths.settings}/*`} element={<Settings />} />
    </Routes>
);
